exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "div[class^=col][data-v-13f4cf75]{padding-left:7px;padding-right:7px}.rowlTop[data-v-13f4cf75]{margin-bottom:-30px!important}.rowlBot[data-v-13f4cf75]{margin-top:-30px!important}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/regionsChart.vue"],"names":[],"mappings":"AACA,iCACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,0BACE,6BAAgC,CACjC,AACD,0BACE,0BAA6B,CAC9B","file":"regionsChart.vue","sourcesContent":["\ndiv[class^=\"col\"][data-v-13f4cf75] {\n  padding-left: 7px;\n  padding-right: 7px;\n}\n.rowlTop[data-v-13f4cf75] {\n  margin-bottom: -30px !important;\n}\n.rowlBot[data-v-13f4cf75] {\n  margin-top: -30px !important;\n}\n\n/* Some styles live in App.vue file*/\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-13f4cf75","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboards/car/mainCar/regionsChart.vue
// module id = 892
// module chunks = 14